import { amountToDisplayValue, ComponentsGroup, SkeletonText, Spacing, Text } from '@billy/design-system'
import map from 'lodash/map'
import { ReactElement } from 'react'

import { OverviewStats } from '../../types/overviewStats'

interface OverviewLabelsProps {
  stats: OverviewStats
  isLoading: boolean
}

export const OverviewLabels = ({ stats, isLoading }: OverviewLabelsProps): ReactElement => (
  <ComponentsGroup spacing={Spacing.S32}>
    {map(stats, (stat, key: string) => {
      const { name, amount, colorVariant } = stat
      return (
        <ComponentsGroup key={key} spacing={Spacing.S6}>
          <Text variant="bodySM" colorVariant="secondary">
            {name}:
          </Text>
          {isLoading ? (
            <SkeletonText variant="h4" width={80} />
          ) : (
            <Text variant="h4" colorVariant={colorVariant}>
              {amountToDisplayValue(amount, amount !== 0)}
            </Text>
          )}
        </ComponentsGroup>
      )
    })}
  </ComponentsGroup>
)
